import Marquee from "react-fast-marquee";

const WORDS = ["ELECTRIC", "CONNECTED", "SUSTAINABLE", "EFFICIENT", "ZERO-EMISSION", "DATA-DRIVEN"];

export default function MarqueeStrip() {
  return (
    <section data-testid="marquee-section" className="overflow-hidden py-20" aria-hidden="true">
      <Marquee speed={36} gradient={false} pauseOnHover={false}>
        {WORDS.map((w) => (
          <span key={w} className="mx-8 flex items-center gap-8">
            <span className="text-outline-volt whitespace-nowrap font-display text-7xl font-bold tracking-tighter md:text-8xl">
              {w}
            </span>
            <span className="block h-2.5 w-2.5 bg-volt/60" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
